<template>
  
    <div class="ms-2 mt-10 h-full" v-if="tokenId != '' && !$apollo.loading">

        <div v-if="user.length" class="w-full">
        
            <div v-if="!displayBusinessInfo && !displayInstructorInfo && !displayBusinessSessions && !displayInstructorSessions"
            class="sticky top-0 pb-2 bg-white w-full">

                <div class="w-full flex justify-center">

                    <add-private class="mt-6 lg:mt-8" :userId="user[0].id" :reload="myReload"/>
                </div>

                <div 
                class="w-full flex justify-center">

                    <button  class=" mt-2 lg:my-6 text-center text-white font-bold rounded-lg 
                    p-1 lg:p-5 bg-pink-400 w-48 h-12 lg:h-16 lg:w-1/6"
                    @click="isBusiness=!isBusiness">{{$t('search.goTo')}} <label v-if="isBusiness">{{$t('search.instructors')}}
                    </label><label v-else>{{$t('menu.business')}}</label></button>
                </div>
            </div>
            
            <div>
                <div v-if="isBusiness">

                    <div v-if="displayBusinessInfo && selectedBusiness != null">
                    
                        <button  class=" mt-10 mb-10 text-center rounded-lg p-5 bg-red-400" @click="closeBusinessInfo">{{$t('profile.close')}}</button>

                        <!-- <customer-business-info :businessInfo="selectedBusiness"></customer-business-info> -->
                        <full-business-page :businessId="selectedBusiness.id"
                        :isFromBrowse="true"/>

                    </div>

                    <!-- <div v-else-if="displayBusinessSessions && selectedBusiness != null">
                    
                        <button class=" mt-10 mb-10 text-center rounded-lg p-5 bg-red-400" @click="closeBusinessSessions">{{$t('search.back')}}</button>

                        <customer-business-sessions :myBusiness="selectedBusiness"></customer-business-sessions>
                    </div> -->

                    <div v-else>
                        
                        <div class=" bg-white pb-4 myCenter fixed">

                            <search-component class="" :name="'Businesses'" :myList="business"
                            :sendResultsTo="businessSearch"/>
                        </div>

                        <div class="pt-20">

                            <all-businesses :business="filteredBusiness" 
                            :showInfoMethod="showBusinessInfo" />
                        </div>

                        <div class="myFixedPaddingHeight">

                        </div>
                    </div>
                </div>

                <div v-else>

                    <div v-if="displayInstructorInfo && selectedInstructor != null">
                    
                        <button  class=" mt-10 mb-10 text-center rounded-lg p-5 bg-red-400" @click="closeInstructorInfo">{{$t('profile.close')}}</button>

                        <!-- <customer-instructor-info :brandInfo="selectedInstructor"></customer-instructor-info> -->
                        <full-instructor-page :instructorId="selectedInstructor.id"/>
                    </div>

                    <!-- <div v-else-if="displayInstructorSessions && selectedInstructor != null">
                    
                        <button class=" mt-10 mb-10 text-center rounded-lg p-5 bg-red-400" @click="closeInstructorSessions">{{$t('search.back')}}</button>

                        <customer-instructor-sessions :myInstructor="selectedInstructor" ></customer-instructor-sessions>
                    </div> -->

                    <div v-else>

                        <div class=" bg-white pb-4 myCenter fixed">

                            <search-component class="" :name="'instructors'" :myList="instructor"
                            :sendResultsTo="instructorsSearch"/>
                        </div>

                        <div class="pt-20">

                            <all-instructors :instructor="filteredInstructors"
                            :showInfoMethod="showInstructorInfo"/>
                        </div>

                        <div class="myFixedPaddingHeight">

                        </div>
                    </div>
                </div>

                <div v-if="isIos()" class="h-32">
                </div>
            </div>   
        </div>
        
        <div v-else class="ml-2 mr-2 mb-2 lg:ml-20 lg:mr-20 lg:mb-20 items-center rounded-full bg-pink-200 p-2 lg:p-10">

            <div class="mt-4">

                <div>
                    <label><strong>{{$t('business.profileFirst')}}</strong></label>
                </div>

                <div class="mt-6">
                    <button 
                    class="w-48 lg:rounded-lg rounded bg-pink-500 text-white text-sm 
                    lg:text-md font-bold h-6 lg:h-12 border-blue-500 border text-center p-1"
                    @click="$router.push({ name: 'profile'});
                    "> {{$t('profile.goToProfile')}}</button>
                </div>
            </div>
        </div>
    </div>
    
    <div v-else class="w-full flex justify-center mt-10">
        
        <ring-loader ></ring-loader> 
    </div>
</template>

<script>

import myQueries from '../hasura/myQueries';

// import fullBusinessPage from '../views/FullBusinessPage';

// import fullInstructorPage from '../views/FullInstructorPage';

import fullBusinessPage from '../components-v2/MyPages/BusinessPage';

import fullInstructorPage from '../components-v2/MyPages/InstructorPage';


import AllBusinesses from '../components-v2/myLists/AllBussinesses';

import AllInstructors from '../components-v2/myLists/AllInstructors';

import searchComponent from '../components/SearchComponent';

// import CustomerBusinessInfo from'../components/CustomerBusinessInfo';

// import CustomerInstructorInfo from'../components/CustomerInstructorInfo';

// import CustomerBusinessSessions from '../components/CustomerBusinessSessions';

// import CustomerInstructorSessions from '../components/CustomerInstructorSessions';

import AddPrivate from '../components/AddPrivate';

import componentsHelpers from '../classes/componentHelpers';

export default {

    created(){

    },

    mounted(){

        // localStorage.setItem('clientLayout2', 'PnadiSearch');

        this.$layoutType = 0;
        
        if(localStorage.hasOwnProperty("businessView")){

            this.isBusinessView = localStorage.getItem('businessView');
        }
    },

    components: {
        
        searchComponent,
        AllBusinesses,
        AllInstructors,
        // CustomerBusinessInfo,
        // CustomerInstructorInfo,
        // CustomerBusinessSessions,
        // CustomerInstructorSessions,
        AddPrivate,
        fullBusinessPage,
        fullInstructorPage
    },

    methods: {


        myReload(){

            location.reload();
        },

        isIos(){

            // alert(`isIos: ${componentsHelpers.isIos()}`)
            return componentsHelpers.isIos();
        },
        
        showBusinessInfo(business){

            this.displayBusinessInfo = true;
            this.selectedBusiness = business;
        },

        showInstructorInfo(instructor){

            this.displayInstructorInfo = true;
            this.selectedInstructor = instructor;
        },

        closeBusinessInfo(){

            this.displayBusinessInfo = false;
            this.selectedBusiness = null;
        },

        closeInstructorInfo(){

            this.displayInstructorInfo = false;
            this.selectedInstructor = null;
        },

        showBusinessSessions(business){

            this.displayBusinessSessions = true;
            this.selectedBusiness = business;
        },

        showInstructorSessions(instructor){

            this.displayInstructorSessions = true;
            this.selectedInstructor = instructor;
        },

        closeBusinessSessions(){

            this.displayBusinessSessions = false;
            this.selectedBusiness = null;
        },

        closeInstructorSessions(){

            this.displayInstructorSessions = false;
            this.selectedInstructor = null;
        },

        instructorsSearch(results){

            this.filteredInstructors = results;
        },

        businessSearch(results){

            this.filteredBusiness = results;

            // console.log(`filteredBusinessResults: ${JSON.stringify(this.filteredBusiness)}`);
        }
    },

    apollo: {

        withUser:{

            query: myQueries.token_and_user_query,

            update(data){

                this.tokenId = data.token[0].id;

                this.user.push(data.token[0].user);
            },

            error(error){
                
                if(this.userInfoError == ''){

                    this.userInfoError = error;

                    componentsHelpers.sendError(this.$apollo, this.userId,'Search', 'main', 'withUser', error);

                    componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
                }
            }
        },

        business:{

            query: myQueries.all_business_query,

            update(data){

                this.filteredBusiness = data.business.filter(item=>item);

                return data.business;
            },
            
            error(error){

                if(this.businessInfoError == ''){

                    this.businessInfoError = error;
                    
                    componentsHelpers.sendError(this.$apollo, this.userId,'Search', 'main', 'business', error);

                    componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
                }
            }
        },

        brandInstructor:{

            query: myQueries.instructor_query,

            update(data){
                
                this.filteredInstructors = data.brand.filter(item=>item);
                this.instructor = data.brand;

                return data.brand;
            },
            
            error(error){

                if(this.brandInstructorError == ''){

                    this.brandInstructorError = error;

                    componentsHelpers.sendError(this.$apollo, this.userId,'Search', 'main', 'brandInstructor', error);

                    componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
                    
                    this.brandInstructorError = JSON.stringify(error);
                }
            }
        }
    },

    data: function() {
    
        return{

            isBusiness: true,
            business: [],
            searchInput: '',
            resultsArray: [],
            tokenId:0 ,
            user: [],
            instructor: [],
            filteredInstructors:[],
            filteredBusiness: [],
            displayBusinessInfo: false,
            displayInstructorInfo: false,
            displayBusinessSessions: false,
            displayInstructorSessions: false,
            selectedBusiness: null,
            selectedInstructor: null,
            isBusinessView: 'false',
            userInfoError: false,
            businessInfoError: false,
            brandInstructorError: false,
        }
    }
}
</script>

<style>

</style>